import React from 'react';
import { Panel, IconButton } from 'rsuite';
import { Link } from 'react-router-dom';
import { Plus } from '@rsuite/icons';
import PageContainer from '../components/PageContainer';
import TransformationsTable from '../components/TransformationsTable';

function Header() {
  return (
    <Link to="/transformations/add">
      <IconButton icon={<Plus />}>
        Add transformation
      </IconButton>
    </Link>
  );
}

function TransformationsPage() {
  return (
    <PageContainer
      title="XML-Morph"
      header={<Header />}
    >
      <Panel header={<h4>Items</h4>} bordered>
        <TransformationsTable />
      </Panel>
    </PageContainer>
  );
}

export default TransformationsPage;
